declare const process: {
  env: Record<string, string | undefined>;
};

export const isDevelopmentEnvironment = (nodeEnvironment?: string): boolean => (
  nodeEnvironment !== "production"
);

export const isDevelopmentHost = (hostname: string): boolean => (
  hostname === 'localhost'
  || hostname === '127.0.0.1'
  || hostname === '[::1]'
);

const runtimeNodeEnvironment = typeof process === 'undefined' ? undefined : process.env?.NODE_ENV;
const runtimeLocation = typeof window === 'undefined' ? undefined : window.location;

/** Keep the gallery local to Parcel's development server when no env shim exists. */
export const isDevelopmentBuild = runtimeNodeEnvironment
  ? isDevelopmentEnvironment(runtimeNodeEnvironment)
  : isDevelopmentHost(runtimeLocation?.hostname ?? '');
